import VueRouter from 'vue-router'
import comum from '@/views/routers/routes/comum'
import adesao from '@/views/routers/routes/adesao'
import ata from '@/views/routers/routes/ata'
import documento from '@/views/routers/routes/documento'
import relatorios from '@/views/routers/routes/relatorios'

const router = new VueRouter({
	routes: [...comum, ...adesao, ...ata, ...documento, ...relatorios]
})

export default router
